export const debounce = (fn: any, wait: number) => {
  let t

  return (...args) => {
    clearTimeout(t)
    t = setTimeout(() => fn.apply(this, args), wait)
  }
}

export const throttle = <T extends (...args: any[]) => void>(
  callback: T,
  timeout: number,
): ((...args: Parameters<T>) => void) => {
  let timer: ReturnType<typeof setTimeout> | null = null

  return (...args: Parameters<T>) => {
    if (timer) return

    timer = setTimeout(() => {
      callback(...args)
      clearTimeout(timer)
      timer = null
    }, timeout)
  }
}
